import { VHeaders } from '@/models/pagedlistmodel';

export function getDetailsHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.lineType'
      ) as string,
      value: 'lineType',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.laborOpCode'
      ) as string,
      value: 'laborOpCode',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.sequenceNumber'
      ) as string,
      value: 'sequenceNumber',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.serviceLineNumber'
      ) as string,
      value: 'serviceLineNumber',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.serviceType'
      ) as string,
      value: 'serviceType',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.actualRetailAmount'
      ) as string,
      value: 'actualRetailAmount',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.technicianId'
      ) as string,
      value: 'technicianID',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.linePaymentMethod'
      ) as string,
      value: 'linePaymentMethod',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.transCode'
      ) as string,
      value: 'transCode',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.laborHours'
      ) as string,
      value: 'laborHours',
    },
    {
      text: vm.$parent.$t(
        'appointmentsDetail.appointmentDetailsGrid.laborCostHours'
      ) as string,
      value: 'laborCostHours',
    },
  ];
}
